import React from 'react';
import styles from '../../styles/components/answers/NumericTextField.module.css';
import { BaseNumericValidation } from '../../helpers/validationBuilder';

export interface NumericTextFieldData {
  value: number | null;
  error: string | null;
  validation: BaseNumericValidation;
  onCompletion?: (v: number | null, e: string | null) => void;
  key?: string;
  tabIndex?: number;
}

export const NumericTextField: React.FC<NumericTextFieldData> = data => {
  return (
    <div className={styles.inputContainer}>
      <input
        tabIndex={data.tabIndex}
        className={data.error ? styles.inputWithError : styles.input}
        type="number"
        min="0"
        value={data.value != null ? data.value : ''}
        onChange={e => {
          const v = parseInt(e.target.value);
          if (e.target.value.length > 0) {
            const err = data.validation(v);
            data.onCompletion && data.onCompletion(v, err);
          } else {
            //User Cleans input
            data.onCompletion && data.onCompletion(null, null);
          }
        }}
      />
    </div>
  );
};
